export const roles = {
  admin: "Admin",
  managingDirector: "Managing Director",
  BusinessDevelopmentHod: "Business Development (HOD)",
  executiveLeadership: "Executive Leadership",
  viewOnly: "View Only",
  readOnly:"Read Only",
  managerfinance: "Manager Finance",
  ceo: "CEO",
  factorymanager: "Factory Manager",
  productionplanning: "Production Planning",
  generalUser: "General User",
  gmc: "GMC",
  marketingExecutive: "Marketing Executive",
  purchaseExecutiveGCview: "Purchase Executive GC View",
  managerCommerical: "Manager Commercial",
  commercialHod: "Commercial HOD",
  commercialExecutive: "Commercial Executive",
  commercialAssociative: "Commercial Associate",
  asstManagerPurchase: "Assistant Manager Purchase GC",
  managerPurchaseGC: "Manager Purchase GC",
  GeneralManagerPurchase: "General Manager Purchase",
  managerGCStores: "Manager GC Stores",
  managerStoresPackingAndGC: "Manager Stores Packing and GC",
  purchaseExecutiveGC: "Purchase Executive GC",
  gcStoresExecutive: "GC Stores Executive",
  srManager: "Sr.Manager",
  qcManager: "Quality Manager",
  qcHead: "Quality Head",
  accountsExecutive: "Accounts Executive",
  accountsManager: "Accounts Manager",
  vendor: "Vendor",
  marketingRepresentative: "Marketing Representative",
  managerPackagingDevelopment: "Manager Packaging Development",
  purchaseManager: "Purchase Manager",
  managerPurchaseGCQuotes: "Manager Purchase GC-Quotes",
  managerPurchasePackaging: "Manager Purchase Packing Materials",
  BusinessDevelopmentManager: "Business Development Manager",
  packingExecutive: "Manager Packaging Development",
  purchaseExecutiveME: "Purchase Executive M&E",
  rdManager: "R&D Manager",
  AnalystQA: "Analyst QA",
  productionAssistant: "Production Assistant",
  rdAssociate: "R&D Associate",
  BDManager: "BD Manager",
  BusinessDevelopmentExecutive: "Business Development Executive",
  Auditor: "Auditor",
  GmProjects: "GM Projects",
  Chairman: "Chairman",
  BDDomestic: "Business Development Manager - Domestic",
  ProductionManager: "Production Manager",
  RDManagerBD: "R&D Manager (BD)",
  factoryPackingManager: "Factory Packing Manager",
  GMPacking : "GM Packing",
  managerPurchaseGCNCL: "Manager Purchase GC (NCL)",
  purchaseExecutiveGCNCL: "Purchase Executive GC (NCL)",
  generalDirector: "General Director",
};

export const statuses = {
  readyForOrder: "Ready For Order",
};

export const routes = {
  settings: "/settings",
  createsettings: "/settings/create",
  editsettings: "/settings/:taxId/edit",
  viewsettings: "/settings/:taxId/view",
  home: "/home",
  dashboard: "/dashboard",
  leads: "/leads",
  createLead: "/leads/create",
  editLead: "/leads/:leadId/edit",
  viewLead: "/leads/:leadId/view",
  deleteLead: "/leads/:leadId/delete",
  accounts: "/accounts",
  viewAccount: "/accounts/:accountId/view",
  editAccount: "/accounts/:accountId/edit",
  createContact: "/accounts/:accountId/contacts/create",
  createSampleRequestFromAccount: "/accounts/:accountId/sample-request/create",
  createQuoteFromAccount: "/accounts/:accountId/quote/create",
  contacts: "/contacts",
  viewContact: "/contacts/:contactId/view",
  editContact: "/contacts/:contactId/edit",
  addBillingAddressOnContact:
    "/contacts/:accountId/:contactId/billingAddress/add",
  viewBillingAddressOnContact:
    "/contacts/:accountId/:contactId/:billingId/billingAddress/view",
  viewBillingOnContact:
    "/contacts/:accountId/:contactId/:billingId/billing/view",
  viewShippingOnContact:
    "/contacts/:accountId/:contactId/:shippingId/shipping/view",
  viewshippingAddressOnContact:
    "/contacts/:accountId/:contactId/:shippingId/shippingAddress/view",
  addShippingAddressOnContact:
    "/contacts/:accountId/:contactId/shippingAddress/add",
  editBillingAddressOnContact:
    "/contacts/:accountId/:contactId/billingAddress/edit",
  editShippingAddressOnContact:
    "/contacts/:accountId/:contactId/shippingAddress/edit",
  sampleRequest: "/sample-request",
  createSampleRequest: "/sample-request/create",
  viewSampleRequest: "/sample-request/:sampleId/view",
  editSampleRequest: "/sample-request/:sampleId/edit",
  addSampleItem: "/sample-request/:sampleId/sample-item/create",
  viewSampleItem: "/sample-request/:sampleId/sample-item/:sampleItemId/view",
  editSampleItem: "/sample-request/:sampleId/sample-item/:sampleItemId/edit",
  //Master Sample
  masterSample: "/master-sample",
  createMasterSample: "/master-sample/create",
  viewMasterSample: "/master-sample/:masterSampleId/view",
  editMasterSample: "/master-sample/:MSId/edit",
  deleteMasterSample: "/master-sample/:masterSampleId/delete",
  // alternative sample
  alternativeSample: "/alternative-sample",
  createAlternativeSample: "/alternative-sample/create",
  viewAlternativeSample: "/alternative-sample/:alternativeSampleId/view",
  editAlternativeSample: "/alternative-sample/:alternativeSampleId/edit",
  deleteAlternativeSample: "/alternative-sample/:alternativeSampleId/delete",
  //customer sample
  customerSample: "/customer-sample",
  createCustomerSample: "/customer-sample/create",
  viewCustomerSample: "/customer-sample/:customerSampleId/view",
  editCustomerSample: "/customer-sample/:customerSampleId/edit",
  deleteCustomerSample: "/customer-sample/:customerSampleId/delete",
   //quotation
   quotation: "/quotation",
   createQuotation: "/quotation/create",
   editQuotation: "/quotation/:quotationId/edit",
   viewQuotation: "/quotation/:quotationId/view",
   createQuotationItem: "/quotation-item/:accountId/:quotationId/:quoteNumber/create",
   viewQuotationItem: "/quotation-item/:accountId/:quotationItemId/view",
   viewPendingQuotationItem: "/quotation-item/:quotationItemId/view",
   editQuotationItem: "/quotation-item/:accountId/:quotationId/:quotationItemId/edit",
  //order
  order: "/order",
  orderDetails: "order/:orderId/view",
  createOrder: "/order/create",
  //orderlineitem
  orderLineItem: "/orderlineitem",
  orderLineItemDetails: "/orderlineitem/:orderlineitemId/view",
  //orderdispatch
  orderDispatchDetails: "/orderdispatch/:orderdispatchId/view",
  orderDispatch: "/orderdispatch",
  //
  users: "/users",
  createUser: "/users/create",
  viewUser: "/users/:userId/view",
  editUser: "/users/:userId/edit",
  contractReports: "/purchase-order/contract-reports",
  purchaseOrders: "/purchase-order",
  createPurchaseOrder: "/purchase-order/create",
  viewPurchaseOrder: "/purchase-order/:poid/view",
  editPurchaseOrder: "/purchase-order/:poid/edit",
  viewDispatch: "/purchase-order/:poid/dispatch/:dispatchId/view",
  debitNoteGC: "/debit-note-gc",
  createDebitNoteGC: "/debit-note-gc/create",
  viewDebitNoteGC: "/debit-note-gc/:debitNoteId/view",
  editDebitNoteGC: "/debit-note-gc/:debitNoteId/edit",
  mrin: "/mrin",
  createMRIN: "/mrin/create",
  editMRIN: "/mrin/:mrinId/edit",
  viewMRIN: "/mrin/:mrinId/view",
  gc: "/gc",
  createGC: "/gc/create",
  editGC: "/gc/:gcId/edit",
  viewGC: "/gc/:gcId/view",
  supplier: "/supplier",
  createSupplier: "/supplier/create",
  editSupplier: "/supplier/:supplierId/edit",
  viewSupplier: "/supplier/:supplierId/view",
  packingType: "/packing-type",
  createpackingType: "/packing-type/:packingtypeId/create",
  editpackingType: "/packing-type/:packingtypeId/:packingId/edit",
  viewpackingType: "/packing-type/:packingId/view",
  login: "/login",
  authenticator: "/authenticator",
  vendor: "/vendor",
  dispatchinfo: "/dispatchinfo",
  allocation: "/allocation",
  gcdailyrates: "/gcdailyrates",
  gcenquiry: "/gcenquiry",
  editgcdailyrates: "/gcdailyrates/:gcdailyratesId/edit",
  creategcdailyrates: "/gcdailyrates/create",
  viewgcdailyrates: "/gcdailyrates/:gcdailyratesId/view",
  editgcenquiry: "/gcenquiry/:gcenquiryId/edit",
  creategcenquiry: "/gcenquiry/create",
  viewgcenquiry: "/gcenquiry/:gcenquiryId/view",
  gcrequired: "/gcrequired",
  gcrequiredview: "/gcrequired/:GcRequiredId/view",
  editallocation: "/allocation/:allocationId/edit",
  createallocation: "/allocation/:allocationId/create",
  viewallocation: "/allocation/:allocationId/view",
  vendorLogin: "/login/vendor",
  forget: "/forget",
  packaging: "/packaging",
  viewPackaging: "/packaging/:packagingId/view",
  //customer sample
  blendSheet: "/blend-sheet",
  auditreports: "/auditreports",
  createBlendSheet: "/blend-sheet/create",
  viewBlendSheet: "/blend-sheet/:blendSheetId/view",
  editBlendSheet: "/blend-sheet/:blendSheetId/edit",
  // certification
  certification: "/certification",
  createcertification: "/certification/create",
  editcertification: "/certification/:certificationId/edit",
  viewcertification: "/certification/:certificationId/view",
  // DispatchNew

  ViewDispatchNew: "/dispatch/:DispatchId/view",
  CreateDispatchNew: "/dispatch/create",
  EditDispatchNew: "/dispatch/:DispatchId/edit",
  // MIV
  miv: "/miv",
  viewMiv: "/miv/:mivId/view",
  editMiv: "/miv/:mivId/edit",
  // Soft Schedule
  softscheduling: "/soft-scheduling",
  viewsoftscheduling: "/soft-scheduling/:orderdispatchId/view",
  editsoftscheduling: "/soft-scheduling/:orderdispatchId/edit",

  sampleInformation: "/sampleInformation",

  // Batch Output
  batchoutput: "/batch-Output",
  editBatchOutput: "/batch-Output/:idsno/edit",
  createBatchOutput: "/batch-Output/:alternativeSampleId?/Create",
  batchOutputDetails: "batch-Output/:idsno/:recordId/view",

  // QLI Reports
  qlireports: "/QLI-Reports",

  // finished goods validity
  FGvalidity: "/fgvalidity",
  createFGvalidity: "/fgvalidity/create",
  editFGvalidity: "/fgvalidity/:fgId/edit",
  FGvalidityDetails: "/fgvalidity/:fgId/view",

  // Production Schedule
  productionSchedule: "/production-schedule",
  createProductionSchedule: "/production-schedule/create",
  editProductionSchedule: "/production-schedule/:psid/edit",
  viewProductionSchedule: "/production-schedule/:psid/detail",
  calendarBlockingProductionSchedule: "/production-schedule/calendar-blocking",
  // PSS
  preShipmentSample: "/pre-shipment-sample",
  createPreShipmentSample: "/pre-shipment-sample/create",
  editPreShipmentSample: "/pre-shipment-sample/:pssid/edit",
  viewPreShipmentSample: "/pre-shipment-sample/:pssid/detail",
  viewPreShipmentSampleLineItem:
    "/pre-shipment-sample/:pssid/:pssLineid/detail",
  editPreShipmentSampleLineItem: "/pre-shipment-sample/:pssid/:pssLineid/edit",

  // Finance module routes
  finance: "/finance-costing",
  createFinanceCosting: "/finance-costing/create",
  editFinanceCosting: "/finance-costing/:FCid/edit",
  viewFinanceCosting: "/finance-costing/:FCid/view",
};

export const roleBasedRoutes = {
  [roles.AnalystQA]: [
    routes.home,
    routes.dashboard,
    routes.mrin,
    routes.viewMRIN,
    routes.editMRIN,
    routes.blendSheet,
    routes.createBlendSheet,
    routes.viewBlendSheet,
    routes.editBlendSheet,
    routes.certification,
    routes.createcertification,
    routes.editcertification,
    routes.viewcertification,
  ],
  [roles.productionplanning]: [
    routes.home,
    routes.dashboard,
    routes.blendSheet,
    routes.viewBlendSheet,
    routes.certification,
    routes.viewcertification,
    routes.alternativeSample,
    routes.viewAlternativeSample,
    routes.customerSample,
    routes.viewCustomerSample,
    routes.order,
    routes.orderDetails,
    routes.orderLineItem,
    routes.orderLineItemDetails,
    routes.orderDispatch,
    routes.orderDispatchDetails,
    routes.softscheduling,
    routes.viewsoftscheduling,
    routes.sampleInformation,
    // Batch Output
    routes.batchoutput,
    routes.createBatchOutput,
    routes.batchOutputDetails,
    routes.editBatchOutput,

    // QLI
    routes.qlireports,

    // production Schedule
    routes.productionSchedule,
    routes.createProductionSchedule,
    routes.editProductionSchedule,
    routes.viewProductionSchedule,
    routes.calendarBlockingProductionSchedule,
  ],
  [roles.admin]: [
    routes.home,
    routes.dashboard,
    routes.auditreports,
    routes.softscheduling,
    routes.viewsoftscheduling,
    routes.editsoftscheduling,
    routes.certification,
    routes.createcertification,
    routes.editcertification,
    routes.viewcertification,
    routes.CreateDispatchNew,
    routes.EditDispatchNew,
    routes.ViewDispatchNew,
    routes.settings,
    routes.createsettings,
    routes.viewsettings,
    routes.editsettings,
    routes.dispatchinfo,
    routes.leads,
    routes.createLead,
    routes.editLead,
    routes.viewLead,
    routes.deleteLead,
    routes.accounts,
    routes.viewAccount,
    routes.editAccount,
    routes.createContact,
    routes.createSampleRequestFromAccount,
    routes.createQuoteFromAccount,
    routes.contacts,
    routes.viewContact,
    routes.editContact,
    routes.addBillingAddressOnContact,
    routes.viewBillingOnContact,
    routes.viewShippingOnContact,
    routes.viewBillingAddressOnContact,
    routes.viewshippingAddressOnContact,
    routes.addShippingAddressOnContact,
    routes.editBillingAddressOnContact,
    routes.editShippingAddressOnContact,
    routes.sampleRequest,
    routes.createSampleRequest,
    routes.viewSampleRequest,
    routes.editSampleRequest,
    routes.addSampleItem,
    routes.viewSampleItem,
    routes.editSampleItem,
    //Master Sample
    routes.masterSample,
    routes.createMasterSample,
    routes.viewMasterSample,
    routes.editMasterSample,
    routes.deleteMasterSample,
    // alternative sample
    routes.alternativeSample,
    routes.createAlternativeSample,
    routes.viewAlternativeSample,
    routes.editAlternativeSample,
    routes.deleteAlternativeSample,
    //customer sample
    routes.customerSample,
    routes.createCustomerSample,
    routes.viewCustomerSample,
    routes.editCustomerSample,
    routes.deleteCustomerSample,
    routes.quotation,
    routes.createQuotation,
    routes.editQuotation,
    routes.viewQuotation,
    routes.createQuotationItem,
    routes.viewQuotationItem,
    routes.viewPendingQuotationItem,
    routes.editQuotationItem,
    //quotes
    routes.quote,
    routes.createQuote,
    routes.editQuote,
    routes.viewQuote,
    routes.createQuoteItem,
    routes.viewQuoteItem,
    routes.viewPendingQuoteItem,
    routes.editQuoteItem,
    routes.users,
    routes.createUser,
    routes.viewUser,
    routes.editUser,
    routes.contractReports,
    routes.purchaseOrders,
    routes.createPurchaseOrder,
    routes.viewPurchaseOrder,
    routes.editPurchaseOrder,
    routes.viewDispatch,
    routes.order,
    routes.createOrder,
    routes.debitNoteGC,
    routes.createDebitNoteGC,
    routes.viewDebitNoteGC,
    routes.editDebitNoteGC,
    routes.mrin,
    routes.createMRIN,
    routes.editMRIN,
    routes.viewMRIN,
    routes.gc,
    routes.createGC,
    routes.editGC,
    routes.viewGC,
    routes.supplier,
    routes.createSupplier,
    routes.editSupplier,
    routes.viewSupplier,
    routes.packingType,
    routes.createpackingType,
    routes.editpackingType,
    routes.viewpackingType,
    routes.login,
    routes.authenticator,
    routes.vendor,
    routes.vendorLogin,
    routes.forget,
    routes.packaging,
    routes.viewPackaging,
    //customer sample
    routes.blendSheet,
    routes.createBlendSheet,
    routes.viewBlendSheet,
    routes.editBlendSheet,
    routes.allocation,
    routes.gcdailyrates,
    routes.creategcdailyrates,
    routes.editgcdailyrates,
    routes.viewgcdailyrates,
    routes.gcenquiry,
    routes.creategcenquiry,
    routes.editgcenquiry,
    routes.viewgcenquiry,
    routes.gcrequired,
    routes.gcrequiredview,
    routes.viewallocation,
    routes.editallocation,
    routes.sampleInformation,
    routes.orderLineItem,
    routes.orderLineItemDetails,
    routes.orderDispatch,
    routes.orderDispatchDetails,
    routes.orderDetails,

    // Batch Output
    routes.batchoutput,
    routes.createBatchOutput,
    routes.batchOutputDetails,
    routes.editBatchOutput,

    // QLI Module
    routes.qlireports,

    // fg validity
    routes.FGvalidity,
    routes.createFGvalidity,
    routes.editFGvalidity,
    routes.FGvalidityDetails,

    // production Schedule
    routes.productionSchedule,   
    routes.createProductionSchedule,
    routes.editProductionSchedule,
    routes.viewProductionSchedule,
    routes.calendarBlockingProductionSchedule,

    // pre-shipment-sample
    routes.preShipmentSample,
    routes.createPreShipmentSample,
    routes.editPreShipmentSample,
    routes.viewPreShipmentSample,
    routes.viewPreShipmentSampleLineItem,
    routes.editPreShipmentSampleLineItem,

    // Finance module routes
    routes.finance,
    routes.createFinanceCosting,
    routes.editFinanceCosting,
    routes.viewFinanceCosting,
  ],

  [roles.BDDomestic]: [
    routes.home,
    routes.dashboard,
    routes.customerSample,
    routes.createCustomerSample,
    routes.editCustomerSample,
    routes.viewCustomerSample,
    routes.quotation,
    routes.createQuotation,
    routes.editQuotation,
    routes.viewQuotation,
    routes.createQuotationItem,
    routes.viewQuotationItem,
    routes.viewPendingQuotationItem,
    routes.editQuotationItem,
    routes.viewAlternativeSample,
    routes.leads,
    routes.viewLead,
    routes.createLead,
    routes.editLead,
    routes.deleteLead,
    routes.accounts,
    routes.viewAccount,
    routes.editAccount,
    routes.createContact,
    routes.createSampleRequestFromAccount,
    routes.createQuoteFromAccount,
    routes.viewAccount,
    routes.editAccount,
    routes.createSampleRequestFromAccount,
    routes.createQuoteFromAccount,
    routes.contacts,
    routes.addBillingAddressOnContact,
    routes.viewBillingOnContact,
    routes.viewShippingOnContact,
    routes.viewBillingAddressOnContact,
    routes.viewshippingAddressOnContact,
    routes.addShippingAddressOnContact,
    routes.editBillingAddressOnContact,
    routes.editShippingAddressOnContact,
    routes.viewContact,
    routes.editContact,
    routes.sampleRequest,
    routes.createSampleRequest,
    routes.editSampleRequest,
    routes.addSampleItem,
    routes.viewSampleItem,
    routes.editSampleItem,
    routes.viewSampleRequest,
    routes.order,
    routes.orderDetails,
    routes.orderDispatch,
    routes.softscheduling,
    routes.viewsoftscheduling,
    routes.orderDispatchDetails,
    routes.orderLineItem,
    routes.orderLineItemDetails,
    routes.createOrder,
    routes.certification,
    routes.viewcertification,
    routes.allocation,
    routes.viewallocation,
    routes.alternativeSample,
    routes.createAlternativeSample,
    routes.editAlternativeSample,
    routes.viewAlternativeSample,
    routes.deleteAlternativeSample,
    routes.sampleInformation,
    // QLI
    routes.qlireports,
    // fg validity
    routes.FGvalidity,
    routes.createFGvalidity,
    routes.editFGvalidity,
    routes.FGvalidityDetails,
    //production schedule
    routes.productionSchedule,
    routes.viewProductionSchedule,
    routes.calendarBlockingProductionSchedule,
    // Finance module routes
    routes.finance,
    routes.viewFinanceCosting,
  ],

  [roles.managingDirector]: [
    routes.home,
    routes.dashboard,
    routes.auditreports,
    routes.leads,
    routes.createLead,
    routes.editLead,
    routes.deleteLead,
    routes.dispatchinfo,
    routes.ViewDispatchNew,
    routes.CreateDispatchNew,
    routes.packingType,
    routes.certification,
    routes.createcertification,
    routes.editcertification,
    routes.viewcertification,
    routes.createpackingType,
    routes.viewpackingType,
    routes.editpackingType,
    routes.viewLead,
    routes.users,
    routes.createUser,
    routes.editUser,
    routes.viewUser,
    routes.accounts,
    routes.createContact,
    routes.createSampleRequestFromAccount,
    routes.createQuoteFromAccount,
    routes.viewAccount,
    routes.editAccount,
    routes.contacts,
    routes.addBillingAddressOnContact,
    routes.viewBillingOnContact,
    routes.viewShippingOnContact,
    routes.addShippingAddressOnContact,
    routes.viewBillingAddressOnContact,
    routes.viewshippingAddressOnContact,
    routes.viewContact,
    routes.editContact,
    routes.sampleRequest,
    routes.createSampleRequest,
    routes.editSampleRequest,
    routes.addSampleItem,
    routes.viewSampleItem,
    routes.editSampleItem,
    routes.viewSampleRequest,
    routes.quotation,
    routes.createQuotation,
    routes.editQuotation,
    routes.viewQuotation,
    routes.createQuotationItem,
    routes.viewQuotationItem,
    routes.viewPendingQuotationItem,
    routes.editQuotationItem,
    // routes.samples,
    routes.quote,
    routes.createQuote,
    routes.viewQuote,
    routes.editQuote,
    routes.createQuoteItem,
    routes.editQuoteItem,
    routes.viewQuoteItem,
    routes.order,
    routes.orderLineItem,
    routes.orderLineItemDetails,
    routes.orderDispatch,
    routes.softscheduling,
    routes.orderDispatchDetails,
    routes.createOrder,
    routes.orderDetails,
    routes.viewPendingQuoteItem,
    routes.contractReports,
    routes.purchaseOrders,
    routes.createPurchaseOrder,
    routes.viewPurchaseOrder,
    routes.viewDispatch,
    routes.editPurchaseOrder,
    routes.debitNoteGC,
    routes.viewDebitNoteGC,
    routes.editDebitNoteGC,
    routes.createDebitNoteGC,
    routes.mrin,
    routes.createMRIN,
    routes.editMRIN,
    routes.viewMRIN,
    routes.gc,
    routes.supplier,
    routes.createSupplier,
    routes.editSupplier,
    routes.viewSupplier,
    routes.createGC,
    routes.editGC,
    routes.viewGC,
    routes.masterSample,
    routes.createMasterSample,
    routes.editMasterSample,
    routes.viewMasterSample,
    routes.deleteMasterSample,
    routes.alternativeSample,
    routes.createAlternativeSample,
    routes.editAlternativeSample,
    routes.viewAlternativeSample,
    routes.deleteAlternativeSample,
    routes.customerSample,
    routes.createCustomerSample,
    routes.editCustomerSample,
    routes.viewCustomerSample,
    routes.deleteCustomerSample,
    routes.blendSheet,
    routes.certification,
    routes.createBlendSheet,
    routes.viewBlendSheet,
    routes.editBlendSheet,
    routes.miv,
    routes.viewMiv,
    routes.editMiv,
    routes.softscheduling,
    routes.viewsoftscheduling,
    routes.editsoftscheduling,
    routes.allocation,
    routes.gcdailyrates,
    routes.creategcdailyrates,
    routes.editgcdailyrates,
    routes.viewgcdailyrates,
    routes.gcenquiry,
    routes.creategcenquiry,
    routes.editgcenquiry,
    routes.viewgcenquiry,
    routes.gcrequired,
    routes.gcrequiredview,
    routes.viewallocation,
    routes.editallocation,
    routes.sampleInformation,
    // Batch Output
    routes.batchoutput,
    routes.createBatchOutput,
    routes.batchOutputDetails,
    routes.editBatchOutput,

    // QLI
    routes.qlireports,

    // fg validity
    routes.FGvalidity,
    routes.createFGvalidity,
    routes.editFGvalidity,
    routes.FGvalidityDetails,

    // production Schedule
    routes.productionSchedule,   
    routes.createProductionSchedule,
    routes.editProductionSchedule,
    routes.viewProductionSchedule,
    routes.calendarBlockingProductionSchedule,

    // pre-shipment-sample
    routes.preShipmentSample,
    routes.createPreShipmentSample,
    routes.editPreShipmentSample,
    routes.viewPreShipmentSample,
    routes.viewPreShipmentSampleLineItem,
    routes.editPreShipmentSampleLineItem,

    // Finance module routes
    routes.finance,
    routes.createFinanceCosting,
    routes.editFinanceCosting,
    routes.viewFinanceCosting,
  ],

  [roles.executiveLeadership]: [
    routes.home,
    routes.dashboard,
    routes.leads,
    routes.auditreports,
    routes.allocation,
    routes.gcrequired,
    routes.gcrequiredview,
    routes.viewallocation,
    routes.gcenquiry,
    routes.viewgcenquiry,
    routes.contractReports,
    routes.viewLead,
    routes.users,
    routes.viewUser,
    routes.accounts,
    routes.viewAccount,
    routes.contacts,
    routes.viewBillingAddressOnContact,
    routes.viewshippingAddressOnContact,
    routes.viewContact,
    routes.sampleRequest,
    routes.viewSampleItem,
    routes.viewSampleRequest,
    routes.quotation,
    routes.createQuotation,
    routes.viewQuotation,
    routes.createQuotationItem,
    routes.viewQuotationItem,
    routes.viewPendingQuotationItem,
    routes.editQuotationItem,
    routes.quote,
    routes.viewQuote,
    routes.viewQuoteItem,
    routes.viewPendingQuoteItem,
    routes.purchaseOrders,
    routes.viewPurchaseOrder,
    routes.viewDispatch,
    routes.dispatchinfo,
    routes.ViewDispatchNew,
    routes.debitNoteGC,
    routes.viewDebitNoteGC,
    routes.editDebitNoteGC,
    routes.createDebitNoteGC,
    routes.mrin,
    routes.viewMRIN,
    routes.gc,

    // pre-shipment-sample
    routes.preShipmentSample,
    routes.viewPreShipmentSample,
    routes.viewPreShipmentSampleLineItem,

    routes.supplier,
    routes.viewSupplier,
    routes.viewGC,
    routes.alternativeSample,
    routes.viewAlternativeSample,
    routes.customerSample,
    routes.viewCustomerSample,
    routes.viewpackingType,
    routes.viewMasterSample,
    routes.viewBlendSheet,
    routes.blendSheet,
    routes.certification,
    routes.viewcertification,
    routes.packingType,
    routes.masterSample,
    routes.order,
    routes.orderDetails,
    routes.orderDispatch,
    routes.orderDispatchDetails,
    routes.orderLineItem,
    routes.orderLineItemDetails,
    routes.softscheduling,
    routes.viewsoftscheduling,
    routes.sampleInformation,
    routes.gcdailyrates,
    routes.viewgcdailyrates,
    // Batch Output
    routes.batchoutput,
    routes.createBatchOutput,
    routes.batchOutputDetails,
    routes.editBatchOutput,
     // QLI
     routes.qlireports,
    // fg validity
    routes.FGvalidity,
    routes.FGvalidityDetails,
    // Production Schedule
    routes.productionSchedule,   
    routes.viewProductionSchedule,
    routes.calendarBlockingProductionSchedule,
      // Finance module routes
      routes.finance,
      routes.viewFinanceCosting,
      // packing type
    routes.viewpackingType,
  ],
  [roles.readOnly]: [
    routes.home,
    routes.leads,
    routes.auditreports,
    routes.allocation,
    routes.gcrequired,
    routes.gcrequiredview,
    routes.viewallocation,
    routes.gcenquiry,
    routes.viewgcenquiry,
    routes.contractReports,
    routes.viewLead,
    routes.users,
    routes.viewUser,
    routes.accounts,
    routes.viewAccount,
    routes.contacts,
    routes.viewBillingAddressOnContact,
    routes.viewshippingAddressOnContact,
    routes.viewContact,
    routes.sampleRequest,
    routes.viewSampleItem,
    routes.viewSampleRequest,
    routes.quotation,
    routes.createQuotation,
    routes.viewQuotation,
    routes.createQuotationItem,
    routes.viewQuotationItem,
    routes.viewPendingQuotationItem,
    routes.editQuotationItem,
    routes.quote,
    routes.viewQuote,
    routes.viewQuoteItem,
    routes.viewPendingQuoteItem,
    routes.purchaseOrders,
    routes.viewPurchaseOrder,
    routes.viewDispatch,
    routes.dispatchinfo,
    routes.ViewDispatchNew,
    routes.debitNoteGC,
    routes.viewDebitNoteGC,
    routes.editDebitNoteGC,
    routes.createDebitNoteGC,
    routes.mrin,
    routes.viewMRIN,
    routes.gc,
    routes.supplier,
    routes.viewSupplier,
    routes.viewGC,
    routes.alternativeSample,
    routes.viewAlternativeSample,
    routes.customerSample,
    routes.viewCustomerSample,
    routes.viewpackingType,
    routes.viewMasterSample,
    routes.viewBlendSheet,
    routes.blendSheet,
    routes.certification,
    routes.viewcertification,
    routes.packingType,
    routes.masterSample,
    routes.order,
    routes.orderDetails,
    routes.orderDispatch,
    routes.orderDispatchDetails,
    routes.orderLineItem,
    routes.orderLineItemDetails,
    routes.softscheduling,
    routes.viewsoftscheduling,
    routes.sampleInformation,
    routes.gcdailyrates,
    routes.viewgcdailyrates,
    // Batch Output
    routes.batchoutput,
    routes.createBatchOutput,
    routes.batchOutputDetails,
    routes.editBatchOutput,

    // QLI
    routes.qlireports,
    // Production Schedule
    routes.productionSchedule,
    routes.viewProductionSchedule,
    // Finance module routes
    routes.finance,
    routes.viewFinanceCosting,
    // packing type
    routes.viewpackingType,
  ],

  [roles.viewOnly]: [
    // Home
    routes.home,
    routes.dashboard,
    // Leads
    routes.leads,
    routes.viewLead,
    // Audit Reports
    routes.auditreports,
    // Allocation
    routes.allocation,
    routes.viewallocation,
    // GC Required
    routes.gcrequired,
    routes.gcrequiredview,
    // GC Enquiry
    routes.gcenquiry,
    routes.viewgcenquiry,
    routes.contractReports,
    // Users
    routes.users,
    routes.viewUser,
    // Accounts
    routes.accounts,
    routes.viewAccount,
    // Contacts
    routes.contacts,
    routes.viewBillingAddressOnContact,
    routes.viewshippingAddressOnContact,
    routes.viewContact,
    // Sample Request
    routes.sampleRequest,
    routes.viewSampleItem,
    routes.viewSampleRequest,
    // Quotation
    routes.quotation,
    routes.createQuotation,
    routes.viewQuotation,
    routes.createQuotationItem,
    routes.viewQuotationItem,
    routes.viewPendingQuotationItem,
    routes.editQuotationItem,
    // Purchase Orders
    routes.purchaseOrders,
    routes.viewPurchaseOrder,
    // Dispatch
    routes.viewDispatch,
    routes.dispatchinfo,
    routes.ViewDispatchNew,
    // Debit Note GC
    routes.debitNoteGC,
    routes.viewDebitNoteGC,
    routes.editDebitNoteGC,
    routes.createDebitNoteGC,
    // MRIN
    routes.mrin,
    routes.viewMRIN,
    routes.gc,
    // pre-shipment-sample
    routes.preShipmentSample,
    routes.viewPreShipmentSample,
    routes.viewPreShipmentSampleLineItem,
    // Supplier
    routes.supplier,
    routes.viewSupplier,
    // GC
    routes.viewGC,
    // Alternative Sample
    routes.alternativeSample,
    routes.viewAlternativeSample,
    // Customer Sample
    routes.customerSample,
    routes.viewCustomerSample,
    // packing type
    routes.viewpackingType,
    routes.packingType,
    // Master Sample
    routes.viewMasterSample,
    routes.masterSample,
    // Blend Sheet
    routes.viewBlendSheet,
    routes.blendSheet,
    // Certification
    routes.certification,
    routes.viewcertification,
    //  Order
    routes.order,
    routes.orderDetails,
    routes.orderDispatch,
    routes.orderDispatchDetails,
    routes.orderLineItem,
    routes.orderLineItemDetails,
    // Soft Scheduling
    routes.softscheduling,
    routes.viewsoftscheduling,
    // Sample Information
    routes.sampleInformation,
    // GC Daily Rates
    routes.gcdailyrates,
    routes.viewgcdailyrates,
    // Batch Output
    routes.batchoutput,
    routes.createBatchOutput,
    routes.batchOutputDetails,
    routes.editBatchOutput,
    // QLI
    routes.qlireports,
    // fg validity
    routes.FGvalidity,
    routes.FGvalidityDetails,
    // Production Schedule
    routes.productionSchedule,
    routes.viewProductionSchedule,
    routes.calendarBlockingProductionSchedule,
    // Finance module routes
    routes.finance,
    routes.viewFinanceCosting,
  ],

  [roles.readOnly]: [
    routes.home,
    routes.dashboard,
    routes.leads,
    routes.auditreports,
    routes.allocation,
    routes.gcrequired,
    routes.gcrequiredview,
    routes.viewallocation,
    routes.gcenquiry,
    routes.viewgcenquiry,
    routes.contractReports,
    routes.viewLead,
    routes.users,
    routes.viewUser,
    routes.accounts,
    routes.viewAccount,
    routes.contacts,
    routes.viewBillingAddressOnContact,
    routes.viewshippingAddressOnContact,
    routes.viewContact,
    routes.sampleRequest,
    routes.viewSampleItem,
    routes.viewSampleRequest,
    routes.quotation,
    routes.createQuotation,
    routes.viewQuotation,
    routes.createQuotationItem,
    routes.viewQuotationItem,
    routes.viewPendingQuotationItem,
    routes.editQuotationItem,
    routes.quote,
    routes.viewQuote,
    routes.viewQuoteItem,
    routes.viewPendingQuoteItem,
    routes.purchaseOrders,
    routes.viewPurchaseOrder,
    routes.viewDispatch,
    routes.dispatchinfo,
    routes.ViewDispatchNew,
    routes.debitNoteGC,
    routes.viewDebitNoteGC,
    routes.editDebitNoteGC,
    routes.createDebitNoteGC,
    routes.mrin,
    routes.viewMRIN,
    routes.gc,

    // pre-shipment-sample
    routes.preShipmentSample,
    routes.viewPreShipmentSample,
    routes.viewPreShipmentSampleLineItem,

    routes.supplier,
    routes.viewSupplier,
    routes.viewGC,
    routes.alternativeSample,
    routes.viewAlternativeSample,
    routes.customerSample,
    routes.viewCustomerSample,
    routes.viewpackingType,
    routes.viewMasterSample,
    routes.viewBlendSheet,
    routes.blendSheet,
    routes.certification,
    routes.viewcertification,
    routes.packingType,
    routes.masterSample,
    routes.order,
    routes.orderDetails,
    routes.orderDispatch,
    routes.orderDispatchDetails,
    routes.orderLineItem,
    routes.orderLineItemDetails,
    routes.softscheduling,
    routes.viewsoftscheduling,
    routes.sampleInformation,
    routes.gcdailyrates,
    routes.viewgcdailyrates,
    // Batch Output
    routes.batchoutput,
    routes.createBatchOutput,
    routes.batchOutputDetails,
    routes.editBatchOutput,
    // QLI
    routes.qlireports,
    // fg validity
    routes.FGvalidity,
    routes.FGvalidityDetails,
    // Production Schedule
    routes.productionSchedule,
    routes.viewProductionSchedule,
    routes.calendarBlockingProductionSchedule,
    // Finance module routes
    routes.finance,
    routes.viewFinanceCosting,
    // packing type
    routes.viewpackingType,
  ],

  [roles.managerfinance]: [
    routes.home,
    routes.dashboard,
    routes.leads,
    routes.auditreports,
    routes.allocation,
    routes.gcrequired,
    routes.gcrequiredview,
    routes.viewallocation,
    routes.gcenquiry,
    routes.viewgcenquiry,
    routes.contractReports,
    routes.viewLead,
    routes.users,
    routes.viewUser,
    routes.accounts,
    routes.viewAccount,
    routes.contacts,
    routes.viewBillingAddressOnContact,
    routes.viewshippingAddressOnContact,
    routes.viewContact,
    routes.sampleRequest,
    routes.viewSampleItem,
    routes.viewSampleRequest,
    routes.quotation,
    routes.createQuotation,
    routes.viewQuotation,
    routes.createQuotationItem,
    routes.viewQuotationItem,
    routes.viewPendingQuotationItem,
    routes.editQuotationItem,
    routes.purchaseOrders,
    routes.viewPurchaseOrder,
    routes.viewDispatch,
    routes.dispatchinfo,
    routes.ViewDispatchNew,
    routes.debitNoteGC,
    routes.viewDebitNoteGC,
    routes.editDebitNoteGC,
    routes.createDebitNoteGC,
    routes.mrin,
    routes.viewMRIN,
    routes.gc,
    routes.supplier,
    routes.viewSupplier,
    routes.viewGC,
    routes.alternativeSample,
    routes.viewAlternativeSample,
    routes.customerSample,
    routes.viewCustomerSample,
    routes.viewpackingType,
    routes.viewMasterSample,
    routes.viewBlendSheet,
    routes.blendSheet,
    routes.certification,
    routes.viewcertification,
    routes.packingType,
    routes.order,
    routes.orderDetails,
    routes.orderDispatch,
    routes.orderDispatchDetails,
    routes.orderLineItem,
    routes.orderLineItemDetails,
    routes.softscheduling,
    routes.viewsoftscheduling,
    routes.sampleInformation,
    routes.gcdailyrates,
    routes.viewgcdailyrates,
    // Batch Output
    routes.batchoutput,
    routes.createBatchOutput,
    routes.batchOutputDetails,
    routes.editBatchOutput,
    // QLI
    routes.qlireports,
    // fg validity
    routes.FGvalidity,
    routes.FGvalidityDetails,
    // Finance module routes
    routes.finance,
    routes.createFinanceCosting,
    routes.editFinanceCosting,
    routes.viewFinanceCosting,
  ],

  [roles.Chairman]: [
    routes.home,
    routes.dashboard,
    routes.leads,
    routes.auditreports,
    routes.allocation,
    routes.gcrequired,
    routes.gcrequiredview,
    routes.viewallocation,
    routes.gcenquiry,
    routes.viewgcenquiry,
    routes.contractReports,
    routes.viewLead,
    routes.users,
    routes.viewUser,
    routes.accounts,
    routes.viewAccount,
    routes.contacts,
    routes.viewBillingAddressOnContact,
    routes.viewshippingAddressOnContact,
    routes.viewContact,
    routes.sampleRequest,
    routes.viewSampleItem,
    routes.viewSampleRequest,
    routes.quotation,
    routes.createQuotation,
    routes.viewQuotation,
    routes.createQuotationItem,
    routes.viewQuotationItem,
    routes.viewPendingQuotationItem,
    routes.editQuotationItem,
    routes.purchaseOrders,
    routes.viewPurchaseOrder,
    routes.viewDispatch,
    routes.dispatchinfo,
    routes.ViewDispatchNew,
    routes.debitNoteGC,
    routes.viewDebitNoteGC,
    routes.editDebitNoteGC,
    routes.createDebitNoteGC,
    routes.mrin,
    routes.viewMRIN,
    routes.gc,
    routes.supplier,
    routes.viewSupplier,
    routes.viewGC,
    routes.alternativeSample,
    routes.viewAlternativeSample,
    routes.customerSample,
    routes.viewCustomerSample,
    routes.viewpackingType,
    routes.viewMasterSample,
    routes.viewBlendSheet,
    routes.blendSheet,
    routes.certification,
    routes.viewcertification,
    routes.packingType,
    routes.masterSample,
    routes.order,
    routes.orderDetails,
    routes.orderDispatch,
    routes.orderDispatchDetails,
    routes.orderLineItem,
    routes.orderLineItemDetails,
    routes.softscheduling,
    routes.viewsoftscheduling,
    routes.sampleInformation,
    routes.gcdailyrates,
    routes.viewgcdailyrates,
    // Batch Output
    routes.batchoutput,
    routes.createBatchOutput,
    routes.batchOutputDetails,
    routes.editBatchOutput,

     // QLI
    routes.qlireports,
    // Production Schedule
    routes.productionSchedule,   
    routes.viewProductionSchedule,
    routes.calendarBlockingProductionSchedule,
    // packing type
    routes.viewpackingType,
  ],

  [roles.GmProjects]: [
    routes.home,
    routes.dashboard,
    routes.leads,
    routes.auditreports,
    routes.allocation,
    routes.gcrequired,
    routes.gcrequiredview,
    routes.viewallocation,
    routes.gcenquiry,
    routes.viewgcenquiry,
    routes.contractReports,
    routes.viewLead,
    routes.users,
    routes.viewUser,
    routes.accounts,
    routes.viewAccount,
    routes.contacts,
    routes.viewBillingAddressOnContact,
    routes.viewshippingAddressOnContact,
    routes.viewContact,
    routes.sampleRequest,
    routes.viewSampleItem,
    routes.viewSampleRequest,
    routes.quotation,
    routes.createQuotation,
    routes.viewQuotation,
    routes.createQuotationItem,
    routes.viewQuotationItem,
    routes.viewPendingQuotationItem,
    routes.editQuotationItem,
    routes.quote,
    routes.viewQuote,
    routes.viewQuoteItem,
    routes.viewPendingQuoteItem,
    routes.purchaseOrders,
    routes.viewPurchaseOrder,
    routes.viewDispatch,
    routes.dispatchinfo,
    routes.ViewDispatchNew,
    routes.debitNoteGC,
    routes.viewDebitNoteGC,
    routes.editDebitNoteGC,
    routes.createDebitNoteGC,
    routes.mrin,
    routes.viewMRIN,
    routes.gc,
    routes.supplier,
    routes.viewSupplier,
    routes.viewGC,
    routes.alternativeSample,
    routes.viewAlternativeSample,
    routes.customerSample,
    routes.viewCustomerSample,
    routes.viewpackingType,
    routes.viewMasterSample,
    routes.viewBlendSheet,
    routes.blendSheet,
    routes.certification,
    routes.viewcertification,
    routes.packingType,
    routes.masterSample,
    routes.order,
    routes.orderDetails,
    routes.orderDispatch,
    routes.orderDispatchDetails,
    routes.orderLineItem,
    routes.orderLineItemDetails,
 
    routes.softscheduling,
    routes.viewsoftscheduling,
    routes.sampleInformation,
    routes.gcdailyrates,
    routes.viewgcdailyrates,
    // Batch Output
    routes.batchoutput,
    routes.createBatchOutput,
    routes.batchOutputDetails,
    routes.editBatchOutput,

     // QLI
    routes.qlireports,
  // production Schedule
    routes.productionSchedule,   
    routes.viewProductionSchedule,
    routes.calendarBlockingProductionSchedule,
    // Finance module routes
    routes.finance,
    routes.viewFinanceCosting,
    // packing type
    routes.viewpackingType,
  ],
  [roles.Auditor]: [
    routes.home,
    routes.dashboard,
    routes.leads,
    routes.auditreports,
    routes.allocation,
    routes.gcrequired,
    routes.gcrequiredview,
    routes.viewallocation,
    routes.gcenquiry,
    routes.viewgcenquiry,
    routes.contractReports,
    routes.viewLead,
    routes.users,
    routes.viewUser,
    routes.accounts,
    routes.viewAccount,
    routes.contacts,
    routes.viewBillingAddressOnContact,
    routes.viewshippingAddressOnContact,
    routes.viewContact,
    routes.sampleRequest,
    routes.viewSampleItem,
    routes.viewSampleRequest,
    routes.quotation,
    routes.createQuotation,
    routes.viewQuotation,
    routes.createQuotationItem,
    routes.viewQuotationItem,
    routes.editQuotationItem,
    routes.viewPendingQuotationItem,
    routes.quote,
    routes.viewQuote,
    routes.viewQuoteItem,
    routes.viewPendingQuoteItem,
    routes.viewProductionSchedule,
    routes.calendarBlockingProductionSchedule,
    routes.productionSchedule,  
    routes.purchaseOrders,
    routes.viewPurchaseOrder,
    routes.viewDispatch,
    routes.dispatchinfo,
    routes.ViewDispatchNew,
    routes.debitNoteGC,
    routes.viewDebitNoteGC,
    routes.createDebitNoteGC,
    routes.mrin,
    routes.viewMRIN,
    routes.gc,
    routes.supplier,
    routes.viewSupplier,
    routes.viewGC,
    routes.alternativeSample,
    routes.viewAlternativeSample,
    routes.customerSample,
    routes.viewCustomerSample,
    routes.viewpackingType,
    routes.viewMasterSample,
    routes.viewBlendSheet,
    routes.blendSheet,
    routes.certification,
    routes.viewcertification,
    routes.packingType,
    routes.order,
    routes.orderDetails,
    routes.orderDispatch,
    routes.orderDispatchDetails,
    routes.orderLineItem,
    routes.orderLineItemDetails,
    routes.softscheduling,
    routes.viewsoftscheduling,
    routes.sampleInformation,
    routes.gcdailyrates,
    routes.viewgcdailyrates,

    // Batch Output
    routes.batchoutput,
    routes.createBatchOutput,
    routes.batchOutputDetails,
    routes.editBatchOutput,

    // QLI
    routes.qlireports,

    //fg-validity
    routes.FGvalidity,
    routes.FGvalidityDetails,
    //finance-costing module
    routes.finance,
    routes.viewFinanceCosting,
    //pss sample module
    routes.preShipmentSample,
    routes.viewPreShipmentSample,
    routes.viewPreShipmentSampleLineItem
  ],
  [roles.ceo]: [
    routes.home,
    routes.dashboard,
    routes.leads,
    routes.auditreports,
    routes.allocation,
    routes.gcrequired,
    routes.gcrequiredview,
    routes.viewallocation,
    routes.contractReports,
    routes.viewLead,
    routes.users,
    routes.viewUser,
    routes.accounts,
    routes.viewAccount,
    routes.contacts,
    routes.viewBillingAddressOnContact,
    routes.viewshippingAddressOnContact,
    routes.viewContact,
    routes.sampleRequest,
    routes.viewSampleItem,
    routes.viewSampleRequest,
    routes.quotation,
    routes.createQuotation,
    routes.viewQuotation,
    routes.createQuotationItem,
    routes.viewQuotationItem,
    routes.viewPendingQuotationItem,
    routes.editQuotationItem,
    routes.quote,
    routes.viewQuote,
    routes.viewQuoteItem,
    routes.viewPendingQuoteItem,
    routes.purchaseOrders,
    routes.viewPurchaseOrder,
    routes.viewDispatch,
    routes.dispatchinfo,
    routes.ViewDispatchNew,
    routes.debitNoteGC,
    routes.viewDebitNoteGC,
    routes.editDebitNoteGC,
    routes.createDebitNoteGC,
    routes.mrin,
    routes.viewMRIN,
    routes.gc,
    routes.supplier,
    routes.viewSupplier,
    routes.viewGC,
    routes.alternativeSample,
    routes.viewAlternativeSample,
    routes.customerSample,
    routes.viewCustomerSample,
    routes.viewpackingType,
    routes.viewMasterSample,
    routes.viewBlendSheet,
    routes.blendSheet,
    routes.certification,
    routes.viewcertification,
    routes.packingType,
    routes.masterSample,
    routes.order,
    routes.orderDetails,
    routes.orderDispatch,
    routes.orderDispatchDetails,
    routes.orderLineItem,
    routes.orderLineItemDetails,
 
    routes.softscheduling,
    routes.viewsoftscheduling,
    routes.sampleInformation,
    // Batch Output
    routes.batchoutput,
    routes.createBatchOutput,
    routes.batchOutputDetails,
    routes.editBatchOutput,

    // QLI
    routes.qlireports,
    // Production Schedule
    routes.productionSchedule,   
    routes.viewProductionSchedule,
    // pre-shipment-sample
    routes.preShipmentSample,
    routes.viewPreShipmentSample,
    routes.viewPreShipmentSampleLineItem,
    // Production Schedule
    routes.productionSchedule,   
    routes.viewProductionSchedule,
    routes.calendarBlockingProductionSchedule,
    // packing type
    routes.viewpackingType,
  ],
  [roles.factorymanager]: [
    routes.home,
    routes.dashboard,
    routes.leads,
    routes.certification,
    routes.viewcertification,
    routes.contractReports,
    routes.viewLead,
    routes.viewUser,
    routes.accounts,
    routes.viewAccount,
    routes.contacts,
    routes.viewBillingAddressOnContact,
    routes.viewshippingAddressOnContact,
    routes.viewContact,
    routes.sampleRequest,
    routes.viewSampleItem,
    routes.viewSampleRequest,
    routes.quotation,
    routes.createQuotation,
    routes.viewQuotation,
    routes.createQuotationItem,
    routes.viewQuotationItem,
    routes.viewPendingQuotationItem,
    routes.editQuotationItem,
    routes.quote,
    routes.viewQuote,
    routes.viewQuoteItem,
    routes.viewPendingQuoteItem,
    routes.purchaseOrders,
    routes.viewPurchaseOrder,
    routes.viewDispatch,
    routes.debitNoteGC,
    routes.viewDebitNoteGC,
    routes.editDebitNoteGC,
    routes.createDebitNoteGC,
    routes.mrin,
    routes.viewMRIN,
    routes.gc,
    routes.supplier,
    routes.viewSupplier,
    routes.viewGC,
    routes.alternativeSample,
    routes.viewAlternativeSample,
    routes.customerSample,
    routes.viewCustomerSample,
    routes.viewpackingType,  	
    routes.viewBlendSheet,
    routes.blendSheet,
    routes.createBlendSheet,
    routes.viewBlendSheet,
    routes.editBlendSheet,
    routes.packingType,
    routes.order,
    routes.orderDetails,
    routes.orderDispatch,
    routes.orderDispatchDetails,
    routes.orderLineItem,
    routes.orderLineItemDetails,
    routes.dispatchinfo,
    routes.softscheduling,
    routes.viewsoftscheduling,
    // Batch Output
    routes.batchoutput,
    routes.createBatchOutput,
    routes.batchOutputDetails,
    routes.editBatchOutput,
    // Production Schedule
    routes.productionSchedule,   
    routes.viewProductionSchedule,
    routes.calendarBlockingProductionSchedule,
    //financeCosting
    routes.finance,
    routes.viewFinanceCosting,
    //type-pss
    routes.preShipmentSample,
    routes.viewPreShipmentSample,
    routes.viewPreShipmentSampleLineItem,
  ],
  [roles.gmc]: [
    routes.home,
    routes.dashboard,
    routes.quotation,
    routes.createQuotation,
    routes.viewQuotation,
    routes.createQuotationItem,
    routes.viewQuotationItem,
    routes.viewPendingQuotationItem,
    routes.editQuotationItem,
    routes.quote,
    routes.createQuote,
    routes.viewQuote,
    routes.editQuote,
    routes.createQuoteItem,
    routes.editQuoteItem,
    routes.viewQuoteItem,
  ],

  [roles.marketingExecutive]: [
    routes.home,
    routes.dashboard,
    routes.leads,
    routes.createLead,
    routes.editLead,
    routes.viewLead,
    routes.deleteLead,
    routes.accounts,
    routes.createSampleRequestFromAccount,
    routes.viewAccount,
    routes.editAccount,
    routes.sampleRequest,
    routes.createSampleRequest,
    routes.editSampleRequest,
    routes.addSampleItem,
    routes.viewSampleItem,
    routes.editSampleItem,
    routes.viewSampleRequest,
    routes.quotation,
    routes.createQuotation,
    routes.viewQuotation,
    routes.createQuotationItem,
    routes.viewQuotationItem,
    routes.viewPendingQuotationItem,
    routes.editQuotationItem,
    routes.editQuotation,
    routes.quote,
    routes.createQuote,
    routes.viewQuote,
    routes.editQuote,
    routes.createQuoteItem,
    routes.editQuoteItem,
    routes.viewQuoteItem,
    routes.viewPendingQuoteItem,
    routes.certification,
    routes.viewcertification,

    // QLI
    routes.qlireports,
  ],
  [roles.purchaseExecutiveGCview]: [
    routes.home,
    routes.dashboard,
    routes.purchaseOrders,
    routes.viewPurchaseOrder,
    routes.mrin,
    routes.viewMRIN,
    // Production Schedule
    routes.productionSchedule,
    routes.viewProductionSchedule,
    routes.calendarBlockingProductionSchedule,
    // Batch Output
    routes.batchoutput,
    routes.batchOutputDetails,
  ],
  [roles.managerCommerical]: [
    routes.home,
    routes.dashboard,
    routes.quotation,
    routes.createQuotation,
    routes.viewQuotation,
    routes.createQuotationItem,
    routes.viewQuotationItem,
    routes.viewPendingQuotationItem,
    routes.editQuotationItem,
    routes.quote,
    routes.viewQuote,
    routes.viewQuoteItem,
    routes.viewPendingQuoteItem,
    routes.order,
    routes.orderLineItem,
    routes.orderLineItemDetails,
    routes.orderDispatch,
    routes.orderDispatchDetails,
    routes.createOrder,
    routes.orderDetails,
    routes.miv,
    routes.viewMiv,
    routes.editMiv,
    routes.softscheduling,
    routes.viewsoftscheduling,
    routes.viewCustomerSample,
    // QLI
    routes.qlireports,
    // production Schedule
    routes.productionSchedule,
    routes.createProductionSchedule,
    routes.editProductionSchedule,
    routes.viewProductionSchedule,
    routes.calendarBlockingProductionSchedule,
    // Blend Sheet (View Only)
    routes.blendSheet,
    routes.viewBlendSheet,
  ],
  [roles.commercialExecutive]: [
    routes.home,
    routes.dashboard,
    // Quotation
    routes.quotation,
    routes.createQuotation,
    routes.viewQuotation,
    routes.createQuotationItem,
    routes.viewQuotationItem,
    routes.viewPendingQuotationItem,
    routes.editQuotationItem,
    // Order
    routes.order,
    routes.orderLineItem,
    routes.orderLineItemDetails,
    routes.orderDispatch,
    routes.orderDispatchDetails,
    routes.createOrder,
    routes.orderDetails,
    // softschedule
    routes.softscheduling,
    routes.viewsoftscheduling,
    // QLI
    routes.qlireports,
    // production Schedule
    routes.productionSchedule,
    routes.createProductionSchedule,
    routes.editProductionSchedule,
    routes.viewProductionSchedule,
    routes.calendarBlockingProductionSchedule,
    // Blend Sheet (View Only)
    routes.blendSheet,
    routes.viewBlendSheet,
  ],
  [roles.commercialHod]: [
    routes.home,
    routes.dashboard,
    // Quotation
    routes.quotation,
    routes.createQuotation,
    routes.viewQuotation,
    routes.createQuotationItem,
    routes.viewQuotationItem,
    routes.viewPendingQuotationItem,
    routes.editQuotationItem,
    // Order
    routes.order,
    routes.createOrder,
    routes.orderDetails,
    // order ine
    routes.orderLineItem,
    routes.orderLineItemDetails,
    // order dispatch
    routes.orderDispatch,
    routes.orderDispatchDetails,
    // soft schedule
    routes.softscheduling,
    routes.viewsoftscheduling,
    routes.viewCustomerSample,
    // QLI
    routes.qlireports,
    // production Schedule
    routes.productionSchedule,
    routes.createProductionSchedule,
    routes.editProductionSchedule,
    routes.viewProductionSchedule,
    routes.calendarBlockingProductionSchedule,
  ],
  [roles.commercialAssociative]: [
    routes.home,
    routes.dashboard,
    //order
    routes.order,
    routes.orderDetails,
    //orderlineitem
    routes.orderLineItem,
    routes.orderLineItemDetails,
    //orderdispatch
    routes.orderDispatchDetails,
    routes.orderDispatch,
    // Soft Schedule
    routes.softscheduling,
    routes.viewsoftscheduling,
    // Production Schedule
    routes.productionSchedule,
    routes.viewProductionSchedule,
    routes.calendarBlockingProductionSchedule,
    routes.editProductionSchedule,
    // Blend Sheet (View Only)
    routes.blendSheet,
    routes.viewBlendSheet,
  ],

  [roles.qcManager]: [
    routes.home,
    routes.dashboard,
    routes.customerSample,
    routes.createCustomerSample,
    routes.editCustomerSample,
    routes.viewCustomerSample,
    routes.alternativeSample,
    routes.createAlternativeSample,
    routes.editAlternativeSample,
    routes.viewAlternativeSample,
    routes.mrin,
    routes.createMRIN,
    routes.viewMRIN,
    routes.editMRIN,
    routes.packingType,
    routes.viewpackingType,
    routes.blendSheet,
    routes.certification,
    routes.createBlendSheet,
    routes.viewBlendSheet,
    routes.editBlendSheet,
    routes.sampleRequest,
    routes.createSampleRequest,
    routes.viewSampleRequest,
    routes.editSampleRequest,
    routes.addSampleItem,
    routes.viewSampleItem,
    routes.editSampleItem,
    routes.certification,
    routes.createcertification,
    routes.editcertification,
    routes.viewcertification,
    routes.viewPurchaseOrder,
    routes.purchaseOrders,
    routes.contractReports,
    routes.allocation,
    routes.viewallocation,
    routes.viewDispatch,
    routes.ViewDispatchNew,
    routes.dispatchinfo,
    // Batch Output
    routes.batchoutput,
    routes.createBatchOutput,
    routes.batchOutputDetails,
    routes.editBatchOutput,
    // production Schedule
    routes.productionSchedule,   
    routes.viewProductionSchedule,
    // pre-shipment-sample
    routes.preShipmentSample,
    routes.createPreShipmentSample,
    routes.viewPreShipmentSample,
    routes.viewPreShipmentSampleLineItem,
    routes.editPreShipmentSampleLineItem,
    // production Schedule
    routes.productionSchedule,   
    routes.viewProductionSchedule,
    routes.calendarBlockingProductionSchedule,
    //orderDispatch
    routes.orderDispatch,
    routes.orderDispatchDetails,
  ],

  [roles.qcHead]: [
    routes.home,
    routes.dashboard,
    routes.customerSample,
    routes.createCustomerSample,
    routes.editCustomerSample,
    routes.viewCustomerSample,
    routes.alternativeSample,
    routes.createAlternativeSample,
    routes.editAlternativeSample,
    routes.viewAlternativeSample,
    routes.mrin,
    routes.createMRIN,
    routes.viewMRIN,
    routes.editMRIN,
    routes.packingType,
    routes.viewpackingType,
    routes.blendSheet,
    routes.certification,
    routes.createBlendSheet,
    routes.viewBlendSheet,
    routes.editBlendSheet,
    routes.sampleRequest,
    routes.createSampleRequest,
    routes.viewSampleRequest,
    routes.editSampleRequest,
    routes.addSampleItem,
    routes.viewSampleItem,
    routes.editSampleItem,
    routes.certification,
    routes.createcertification,
    routes.editcertification,
    routes.viewcertification,
    routes.viewPurchaseOrder,
    routes.purchaseOrders,
    routes.contractReports,
    routes.allocation,
    routes.viewallocation,
    routes.viewDispatch,
    routes.ViewDispatchNew,
    routes.dispatchinfo,
    // Batch Output
    routes.batchoutput,
    routes.createBatchOutput,
    routes.batchOutputDetails,
    routes.editBatchOutput,
    // pre-shipment-sample
    routes.preShipmentSample,
    routes.createPreShipmentSample,
    routes.viewPreShipmentSample,
    routes.viewPreShipmentSampleLineItem,
    routes.editPreShipmentSampleLineItem,
    // production Schedule
    routes.productionSchedule,   
    routes.viewProductionSchedule,
    routes.calendarBlockingProductionSchedule,
    //orderDispatch
    routes.orderDispatch,
    routes.orderDispatchDetails,
  ],

  [roles.BusinessDevelopmentManager]: [
    routes.home,
    routes.dashboard,
    routes.customerSample,
    routes.createCustomerSample,
    routes.editCustomerSample,
    routes.viewCustomerSample,
    routes.quotation,
    routes.createQuotation,
    routes.editQuotation,
    routes.viewQuotation,
    routes.createQuotationItem,
    routes.viewQuotationItem,
    routes.viewPendingQuotationItem,
    routes.editQuotationItem,
    routes.quote,
    routes.createQuote,
    routes.viewQuote,
    routes.editQuote,
    routes.alternativeSample,
    routes.viewAlternativeSample,
    routes.createQuoteItem,
    routes.editQuoteItem,
    routes.viewQuoteItem,
    routes.viewPendingQuoteItem,
    routes.leads,
    routes.viewLead,
    routes.createLead,
    routes.editLead,
    routes.deleteLead,
    routes.accounts,
    routes.viewAccount,
    routes.editAccount,
    routes.createContact,
    routes.createSampleRequestFromAccount,
    routes.createQuoteFromAccount,
    routes.viewAccount,
    routes.editAccount,
    routes.createSampleRequestFromAccount,
    routes.createQuoteFromAccount,
    routes.contacts,
    routes.addBillingAddressOnContact,
    routes.viewBillingOnContact,
    routes.viewShippingOnContact,
    routes.viewBillingAddressOnContact,
    routes.viewshippingAddressOnContact,
    routes.addShippingAddressOnContact,
    routes.editBillingAddressOnContact,
    routes.editShippingAddressOnContact,
    routes.viewContact,
    routes.editContact,
    routes.sampleRequest,
    routes.createSampleRequest,
    routes.editSampleRequest,
    routes.addSampleItem,
    routes.viewSampleItem,
    routes.editSampleItem,
    routes.viewSampleRequest,
    routes.order,
    routes.orderDetails,
    routes.orderDispatch,
    routes.softscheduling,
    routes.viewsoftscheduling,
    routes.orderDispatchDetails,
    routes.orderLineItem,
    routes.orderLineItemDetails,
    routes.createOrder,
    routes.certification,
    routes.viewcertification,
    routes.allocation,
    routes.viewallocation,
    routes.sampleInformation,
    // QLI
    routes.qlireports,
    // Finance module routes
    routes.finance,
    routes.createFinanceCosting,
    routes.editFinanceCosting,
    routes.viewFinanceCosting,
    // Production Schedule
    routes.productionSchedule,   
    routes.viewProductionSchedule,
    // Finance module routes
    routes.finance,
    routes.viewFinanceCosting,
    routes.calendarBlockingProductionSchedule,
  ],
  [roles.BDManager]: [
    routes.home,
    routes.dashboard,
    routes.customerSample,
    routes.createCustomerSample,
    routes.editCustomerSample,
    routes.viewCustomerSample,
    routes.quotation,
    routes.createQuotation,
    routes.editQuotation,
    routes.viewQuotation,
    routes.createQuotationItem,
    routes.viewQuotationItem,
    routes.viewPendingQuotationItem,
    routes.editQuotationItem,
    routes.quote,
    routes.createQuote,
    routes.viewQuote,
    routes.editQuote,
    routes.alternativeSample,
    routes.viewAlternativeSample,
    routes.createQuoteItem,
    routes.editQuoteItem,
    routes.viewQuoteItem,
    routes.viewPendingQuoteItem,
    routes.leads,
    routes.viewLead,
    routes.createLead,
    routes.editLead,
    routes.deleteLead,
    routes.accounts,
    routes.viewAccount,
    routes.editAccount,
    routes.createContact,
    routes.createSampleRequestFromAccount,
    routes.createQuoteFromAccount,
    routes.viewAccount,
    routes.editAccount,
    routes.createSampleRequestFromAccount,
    routes.createQuoteFromAccount,
    routes.contacts,
    routes.addBillingAddressOnContact,
    routes.viewBillingOnContact,
    routes.viewShippingOnContact,
    routes.viewBillingAddressOnContact,
    routes.viewshippingAddressOnContact,
    routes.addShippingAddressOnContact,
    routes.editBillingAddressOnContact,
    routes.editShippingAddressOnContact,
    routes.viewContact,
    routes.editContact,
    routes.sampleRequest,
    routes.createSampleRequest,
    routes.editSampleRequest,
    routes.addSampleItem,
    routes.viewSampleItem,
    routes.editSampleItem,
    routes.viewSampleRequest,
    routes.order,
    routes.orderDetails,
    routes.orderDispatch,
    routes.softscheduling,
    routes.viewsoftscheduling,
    routes.orderDispatchDetails,
    routes.orderLineItem,
    routes.orderLineItemDetails,
    routes.createOrder,
    routes.certification,
    routes.viewcertification,
    routes.allocation,
    routes.viewallocation,

    routes.sampleInformation,
    // QLI
    routes.qlireports,
    // Finance module routes
    routes.finance,
    routes.createFinanceCosting,
    routes.editFinanceCosting,
    routes.viewFinanceCosting,
    // Production Schedule
    routes.productionSchedule,   
    routes.viewProductionSchedule,
    routes.calendarBlockingProductionSchedule,
  ],
  [roles.BusinessDevelopmentHod]: [
    routes.home,
    routes.dashboard,
    routes.customerSample,
    routes.createCustomerSample,
    routes.editCustomerSample,
    routes.viewCustomerSample,
    routes.quotation,
    routes.createQuotation,
    routes.editQuotation,
    routes.viewQuotation,
    routes.createQuotationItem,
    routes.viewQuotationItem,
    routes.viewPendingQuotationItem,
    routes.editQuotationItem,
    routes.quote,
    routes.createQuote,
    routes.viewQuote,
    routes.editQuote,
    routes.alternativeSample,
    routes.viewAlternativeSample,
    routes.createQuoteItem,
    routes.editQuoteItem,
    routes.viewQuoteItem,
    routes.viewPendingQuoteItem,
    routes.leads,
    routes.viewLead,
    routes.createLead,
    routes.editLead,
    routes.deleteLead,
    routes.accounts,
    routes.viewAccount,
    routes.editAccount,
    routes.createContact,
    routes.createSampleRequestFromAccount,
    routes.createQuoteFromAccount,
    routes.viewAccount,
    routes.editAccount,
    routes.createSampleRequestFromAccount,
    routes.createQuoteFromAccount,
    routes.contacts,
    routes.addBillingAddressOnContact,
    routes.viewBillingOnContact,
    routes.viewShippingOnContact,
    routes.viewBillingAddressOnContact,
    routes.viewshippingAddressOnContact,
    routes.addShippingAddressOnContact,
    routes.editBillingAddressOnContact,
    routes.editShippingAddressOnContact,
    routes.viewContact,
    routes.editContact,
    routes.sampleRequest,
    routes.createSampleRequest,
    routes.editSampleRequest,
    routes.addSampleItem,
    routes.viewSampleItem,
    routes.editSampleItem,
    routes.viewSampleRequest,
    routes.order,
    routes.orderDetails,
    routes.orderDispatch,
    routes.softscheduling,
    routes.viewsoftscheduling,
    routes.orderDispatchDetails,
    routes.orderLineItem,
    routes.orderLineItemDetails,
    routes.createOrder,
    routes.certification,
    routes.viewcertification,
    routes.allocation,
    routes.viewallocation,

    routes.sampleInformation,
    // QLI
    routes.qlireports,
    // Finance module routes
    routes.finance,
    routes.createFinanceCosting,
    routes.editFinanceCosting,
    routes.viewFinanceCosting,
    // Production Schedule
    routes.productionSchedule,
    routes.viewProductionSchedule,
    routes.calendarBlockingProductionSchedule,
    // Packing Type
    routes.packingType,
    routes.viewpackingType,
  ],
  [roles.BusinessDevelopmentExecutive]: [
    routes.home,
    routes.dashboard,
    routes.customerSample,
    routes.createCustomerSample,
    routes.editCustomerSample,
    routes.viewCustomerSample,
    routes.quotation,
    routes.createQuotation,
    routes.editQuotation,
    routes.viewQuotation,
    routes.createQuotationItem,
    routes.viewQuotationItem,
    routes.viewPendingQuotationItem,
    routes.editQuotationItem,
    routes.quote,
    routes.createQuote,
    routes.viewQuote,
    routes.editQuote,
    routes.alternativeSample,
    routes.viewAlternativeSample,
    routes.createQuoteItem,
    routes.editQuoteItem,
    routes.viewQuoteItem,
    routes.viewPendingQuoteItem,
    routes.leads,
    routes.viewLead,
    routes.createLead,
    routes.editLead,
    routes.deleteLead,
    routes.accounts,
    routes.viewAccount,
    routes.editAccount,
    routes.createContact,
    routes.createSampleRequestFromAccount,
    routes.createQuoteFromAccount,
    routes.viewAccount,
    routes.editAccount,
    routes.createSampleRequestFromAccount,
    routes.createQuoteFromAccount,
    routes.contacts,
    routes.addBillingAddressOnContact,
    routes.viewBillingOnContact,
    routes.viewShippingOnContact,
    routes.viewBillingAddressOnContact,
    routes.viewshippingAddressOnContact,
    routes.addShippingAddressOnContact,
    routes.editBillingAddressOnContact,
    routes.editShippingAddressOnContact,
    routes.viewContact,
    routes.editContact,
    routes.sampleRequest,
    routes.createSampleRequest,
    routes.editSampleRequest,
    routes.addSampleItem,
    routes.viewSampleItem,
    routes.editSampleItem,
    routes.viewSampleRequest,
    routes.order,
    routes.orderDetails,
    routes.orderDispatch,
    routes.softscheduling,
    routes.viewsoftscheduling,
    routes.orderDispatchDetails,
    routes.orderLineItem,
    routes.orderLineItemDetails,
    routes.createOrder,
    routes.certification,
    routes.viewcertification,
    routes.allocation,
    routes.viewallocation,
    routes.sampleInformation,
    // QLI
    routes.qlireports,
    // Finance module routes
    routes.finance,
    routes.createFinanceCosting,
    routes.editFinanceCosting,
    routes.viewFinanceCosting,
    // Production Schedule
    routes.productionSchedule,   
    routes.viewProductionSchedule,
    // Finance module routes
    routes.finance,
    routes.viewFinanceCosting,
    routes.calendarBlockingProductionSchedule,
  ],
  [roles.asstManagerPurchase]: [
    routes.home,
    routes.dashboard,
    routes.quotation,
    routes.createQuotation,
    routes.viewQuotation,
    routes.createQuotationItem,
    routes.viewQuotationItem,
    routes.viewPendingQuotationItem,
    routes.editQuotationItem,
    routes.quote,
    routes.createQuote,
    routes.viewQuote,
    routes.editQuote,
    routes.createQuoteItem,
    routes.editQuoteItem,
    routes.viewQuoteItem,
    routes.viewPendingQuoteItem,
    routes.purchaseOrders,
    routes.createPurchaseOrder,
    routes.viewPurchaseOrder,
    routes.viewDispatch,
    routes.editPurchaseOrder,
  ],

  [roles.managerPurchaseGC]: [
    routes.home,
    routes.dashboard,
    routes.dispatchinfo,
    routes.CreateDispatchNew,
    routes.ViewDispatchNew,
    routes.gcdailyrates,
    routes.creategcdailyrates,
    routes.editgcdailyrates,
    routes.viewgcdailyrates,
    routes.gcenquiry,
    routes.creategcenquiry,
    routes.editgcenquiry,
    routes.viewgcenquiry,
    routes.debitNoteGC,
    routes.viewDebitNoteGC,
    routes.editDebitNoteGC,
    routes.createDebitNoteGC,
    routes.quotation,
    routes.createQuotation,
    routes.viewQuotation,
    routes.createQuotationItem,
    routes.viewQuotationItem,
    routes.viewPendingQuotationItem,
    routes.editQuotationItem,
    routes.quote,
    routes.createQuote,
    routes.viewQuote,
    routes.editQuote,
    routes.createQuoteItem,
    routes.editQuoteItem,
    routes.viewQuoteItem,
    routes.viewPendingQuoteItem,
    routes.softscheduling,
    routes.viewsoftscheduling,
    routes.purchaseOrders,
    routes.createPurchaseOrder,
    routes.viewPurchaseOrder,
    routes.contractReports,
    routes.viewDispatch,
    routes.editPurchaseOrder,
    routes.mrin,
    routes.createMRIN,
    routes.alternativeSample,
    routes.viewAlternativeSample,
    routes.customerSample,
    routes.viewCustomerSample,
    routes.editMRIN,
    routes.viewMRIN,
    routes.gc,
    routes.supplier,
    routes.createSupplier,
    routes.editSupplier,
    routes.viewSupplier,
    routes.createGC,
    routes.viewGC,
    routes.editGC,
    routes.allocation,
    routes.gcrequired,
    routes.gcrequiredview,
    routes.viewallocation,
    routes.editallocation,
    // Production Schedule
    routes.productionSchedule,   
    routes.viewProductionSchedule,
    // pre-shipment-sample
    routes.preShipmentSample,
    routes.createPreShipmentSample,
    routes.editPreShipmentSample,
    routes.viewPreShipmentSample,
    routes.viewPreShipmentSampleLineItem,
    routes.editPreShipmentSampleLineItem,
    // Production Schedule
    routes.productionSchedule,   
    routes.viewProductionSchedule,
    routes.calendarBlockingProductionSchedule,
    // Batch Output
    routes.batchoutput,
    routes.batchOutputDetails,
  ],
  [roles.GeneralManagerPurchase]: [
    routes.home,
    routes.dashboard,
    routes.order,
    routes.orderLineItem,
    routes.orderLineItemDetails,
    routes.orderDispatch,
    routes.orderDispatchDetails,
    routes.createOrder,
    routes.orderDetails,
    routes.debitNoteGC,
    routes.viewDebitNoteGC,
    routes.editDebitNoteGC,
    routes.createDebitNoteGC,
    routes.quotation,
    routes.createQuotation,
    routes.viewQuotation,
    routes.createQuotationItem,
    routes.viewQuotationItem,
    routes.viewPendingQuotationItem,
    routes.editQuotationItem,
    routes.quote,
    routes.createQuote,
    routes.viewQuote,
    routes.editQuote,
    routes.createQuoteItem,
    routes.editQuoteItem,
    routes.viewQuoteItem,
    routes.viewPendingQuoteItem,
    routes.purchaseOrders,
    routes.createPurchaseOrder,
    routes.viewPurchaseOrder,
    routes.contractReports,
    routes.viewDispatch,
    routes.editPurchaseOrder,
    routes.mrin,
    routes.createMRIN,
    routes.editMRIN,
    routes.viewMRIN,
    routes.gc,
    routes.supplier,
    routes.createSupplier,
    routes.editSupplier,
    routes.viewSupplier,
    routes.createGC,
    routes.viewGC,
    routes.editGC,
  ],
  [roles.rdManager]: [
    routes.home,
    routes.dashboard,
    routes.customerSample,
    routes.createCustomerSample,
    routes.editCustomerSample,
    routes.viewCustomerSample,
    routes.deleteCustomerSample,
    routes.masterSample,
    routes.createMasterSample,
    routes.editMasterSample,
    routes.viewMasterSample,
    routes.deleteMasterSample,
    routes.alternativeSample,
    routes.createAlternativeSample,
    routes.editAlternativeSample,
    routes.viewAlternativeSample,
    routes.deleteAlternativeSample,
    routes.sampleRequest,
    routes.createSampleRequest,
    routes.viewSampleRequest,
    routes.editSampleRequest,
    routes.addSampleItem,
    routes.viewSampleItem,
    routes.editSampleItem,
    routes.mrin,
    routes.createMRIN,
    routes.viewMRIN,
    routes.editMRIN,
    // Batch Output
    routes.batchoutput,
    routes.createBatchOutput,
    routes.batchOutputDetails,
    routes.editBatchOutput,
    // Account Module
    routes.users,
    routes.viewLead,
    routes.viewUser,
    routes.accounts,
    routes.viewAccount,
    routes.contacts,
    routes.viewBillingAddressOnContact,
    routes.viewshippingAddressOnContact,
    routes.viewContact,
    routes.sampleRequest,
    routes.viewSampleItem,
    routes.viewSampleRequest,
    routes.blendSheet,
    routes.viewBlendSheet,

    // Allocation
    routes.allocation,
    routes.viewallocation,
    routes.gc,
    routes.viewGC,

    // fg validity
    routes.FGvalidity,
    routes.createFGvalidity,
    routes.editFGvalidity,
    routes.FGvalidityDetails,
    // Production Schedule
    routes.productionSchedule,   
    routes.viewProductionSchedule,
    // pre-shipment-sample
    routes.preShipmentSample,
    routes.createPreShipmentSample,
    routes.viewPreShipmentSample,
    routes.viewPreShipmentSampleLineItem,
    routes.editPreShipmentSampleLineItem,

    // Production Schedule
    routes.productionSchedule,   
    routes.viewProductionSchedule,
    routes.calendarBlockingProductionSchedule,
  ],
  [roles.RDManagerBD]: [
    routes.home,
    routes.dashboard,
    // Leads
    routes.leads,
    routes.createLead,
    routes.editLead,
    routes.viewLead,
    routes.deleteLead,
    // Accounts
    routes.accounts,
    routes.createSampleRequestFromAccount,
    routes.viewAccount,
    routes.editAccount,
    // Sample Request
    routes.sampleRequest,
    routes.createSampleRequest,
    routes.viewSampleRequest,
    routes.editSampleRequest,
    routes.addSampleItem,
    routes.viewSampleItem,
    routes.editSampleItem,
    // User
    routes.users,
    routes.viewUser,
    // CustomerSample
    routes.customerSample,
    routes.createCustomerSample,
    routes.editCustomerSample,
    routes.viewCustomerSample,
    routes.deleteCustomerSample,
    routes.masterSample,
    routes.createMasterSample,
    routes.editMasterSample,
    routes.viewMasterSample,
    routes.deleteMasterSample,
    routes.alternativeSample,
    routes.createAlternativeSample,
    routes.editAlternativeSample,
    routes.viewAlternativeSample,
    routes.deleteAlternativeSample,
    // MRIN
    routes.mrin,
    routes.createMRIN,
    routes.viewMRIN,
    routes.editMRIN,
    // Batch Output
    routes.batchoutput,
    routes.createBatchOutput,
    routes.batchOutputDetails,
    routes.editBatchOutput,
    // Contacts
    routes.contacts,
    routes.viewBillingAddressOnContact,
    routes.viewshippingAddressOnContact,
    routes.viewContact,
    routes.sampleRequest,
    routes.viewSampleItem,
    routes.viewSampleRequest,
    routes.blendSheet,
    routes.viewBlendSheet,

    // Quotation
    routes.quotation,
    routes.createQuotation,
    routes.viewQuotation,
    routes.createQuotationItem,
    routes.viewQuotationItem,
    routes.viewPendingQuotationItem,
    routes.editQuotationItem,
    routes.editQuotation,
    // Certification
    routes.certification,
    routes.viewcertification,
    // QLI
    routes.qlireports,
    // Allocation
    routes.allocation,
    routes.viewallocation,
    routes.gc,
    routes.viewGC,
    // fg validity
    routes.FGvalidity,
    routes.createFGvalidity,
    routes.editFGvalidity,
    routes.FGvalidityDetails,
    // pre-shipment-sample
    routes.preShipmentSample,
    routes.createPreShipmentSample,
    routes.viewPreShipmentSample,
    routes.viewPreShipmentSampleLineItem,
    routes.editPreShipmentSampleLineItem,
    // Production Schedule
    routes.productionSchedule,   
    routes.viewProductionSchedule,
    routes.calendarBlockingProductionSchedule,
  ],
  [roles.rdAssociate]: [
    routes.home,
    routes.dashboard,
    // CustomerSample
    routes.customerSample,
    routes.createCustomerSample,
    routes.editCustomerSample,
    routes.viewCustomerSample,
    routes.deleteCustomerSample,
    // MasterSample
    routes.masterSample,
    routes.createMasterSample,
    routes.editMasterSample,
    routes.viewMasterSample,
    routes.deleteMasterSample,
    // AlternativeSample
    routes.alternativeSample,
    routes.createAlternativeSample,
    routes.editAlternativeSample,
    routes.viewAlternativeSample,
    routes.deleteAlternativeSample,
    // Sample Request
    routes.sampleRequest,
    routes.createSampleRequest,
    routes.viewSampleRequest,
    routes.editSampleRequest,
    routes.addSampleItem,
    routes.viewSampleItem,
    routes.editSampleItem,
    // MRIN
    routes.mrin,
    routes.createMRIN,
    routes.viewMRIN,
    routes.editMRIN,
    // Batch Output
    routes.batchoutput,
    routes.createBatchOutput,
    routes.batchOutputDetails,
    routes.editBatchOutput,
    // Account Module
    routes.accounts,
    routes.viewAccount,
    // Sample Request
    routes.sampleRequest,
    routes.viewSampleItem,
    routes.viewSampleRequest,
    // Blend Sheet
    routes.blendSheet,
    routes.viewBlendSheet,
    // Allocation
    routes.allocation,
    routes.viewallocation,
    routes.gc,
    routes.viewGC,
    // fg validity
    routes.FGvalidity,
    routes.createFGvalidity,
    routes.editFGvalidity,
    routes.FGvalidityDetails,
    // pre-shipment-sample
    routes.preShipmentSample,
    routes.createPreShipmentSample,
    routes.viewPreShipmentSample,
    routes.viewPreShipmentSampleLineItem,
    routes.editPreShipmentSampleLineItem,
    // Production Schedule
    routes.productionSchedule,
    routes.viewProductionSchedule,
    routes.calendarBlockingProductionSchedule,
  ],
  [roles.managerStoresPackingAndGC]: [
    routes.home,
    routes.dashboard,
    routes.purchaseOrders,
    routes.createPurchaseOrder,
    routes.viewPurchaseOrder,
    routes.viewDispatch,
    routes.editPurchaseOrder,
    routes.mrin,
    routes.createMRIN,
    routes.editMRIN,
    routes.viewMRIN,
    routes.gc,
    routes.createGC,
    routes.editGC,
    routes.viewGC,
  ],

  [roles.purchaseExecutiveGC]: [
    routes.home,
    routes.dashboard,
    routes.purchaseOrders,
    routes.createPurchaseOrder,
    routes.viewPurchaseOrder,
    routes.viewDispatch,
    routes.editPurchaseOrder,
    routes.contractReports,
    routes.allocation,
    routes.gcrequired,
    routes.quotation,
    routes.createQuotation,
    routes.viewQuotation,
    routes.createQuotationItem,
    routes.viewQuotationItem,
    routes.viewPendingQuotationItem,
    routes.editQuotationItem,
    routes.quote,
    routes.viewQuote,
    routes.softscheduling,
    routes.viewsoftscheduling,
    routes.gcrequiredview,
    routes.viewallocation,
    routes.editallocation,
    routes.dispatchinfo,
    routes.CreateDispatchNew,
    routes.ViewDispatchNew,
    routes.debitNoteGC,
    routes.viewDebitNoteGC,
    routes.editDebitNoteGC,
    routes.createDebitNoteGC,
    routes.mrin,
    routes.createMRIN,
    routes.editMRIN,
    routes.viewMRIN,
    routes.gc,
    routes.supplier,
    routes.createSupplier,
    routes.editSupplier,
    routes.viewSupplier,
    routes.createGC,
    routes.editGC,
    routes.viewGC,
    routes.alternativeSample,
    routes.viewAlternativeSample,
    routes.customerSample,
    routes.viewCustomerSample,
    routes.gcdailyrates,
    routes.creategcdailyrates,
    routes.editgcdailyrates,
    routes.viewgcdailyrates,
    routes.gcenquiry,
    routes.creategcenquiry,
    routes.editgcenquiry,
    routes.viewgcenquiry,

    // Batch Output
    routes.batchoutput,
    routes.createBatchOutput,
    routes.batchOutputDetails,
    routes.editBatchOutput,
    // Production Schedule
    routes.productionSchedule,   
    routes.viewProductionSchedule,
    // pre-shipment-sample
    routes.preShipmentSample,
    routes.createPreShipmentSample,
    routes.editPreShipmentSample,
    routes.viewPreShipmentSample,
    routes.viewPreShipmentSampleLineItem,
    routes.editPreShipmentSampleLineItem,
    // Production Schedule
    routes.productionSchedule,   
    routes.viewProductionSchedule,
    routes.calendarBlockingProductionSchedule,
  ],

  [roles.gcStoresExecutive]: [
    routes.home,
    routes.dashboard,
    routes.productionSchedule,
    routes.viewProductionSchedule,
    routes.calendarBlockingProductionSchedule,
    routes.purchaseOrders,
    routes.createPurchaseOrder,
    routes.viewPurchaseOrder,
    routes.viewDispatch,
    routes.editPurchaseOrder,
    routes.mrin,
    routes.createMRIN,
    routes.editMRIN,
    routes.viewMRIN,
    routes.gc,
    routes.createGC,
    routes.viewGC,
    routes.editGC,
    routes.blendSheet,
    routes.createBlendSheet,
    routes.viewBlendSheet,
    routes.editBlendSheet,
    //orderdispatch
    routes.orderDispatchDetails,
    routes.orderDispatch,
  ],

  [roles.srManager]: [
    routes.home,
    routes.dashboard,
    routes.mrin,
    routes.createMRIN,
    routes.editMRIN,
    routes.viewMRIN,
  ],

  [roles.accountsExecutive]: [
    routes.home,
    routes.dashboard,
    routes.mrin,
    routes.createMRIN,
    routes.editMRIN,
    routes.viewMRIN,
    routes.purchaseOrders,
    routes.createPurchaseOrder,
    routes.viewPurchaseOrder,
    routes.viewDispatch,
    routes.editPurchaseOrder,
    routes.debitNoteGC,
    routes.viewDebitNoteGC,
    routes.editDebitNoteGC,
    routes.createDebitNoteGC,
  ],

  [roles.accountsManager]: [
    routes.home,
    routes.dashboard,
    routes.purchaseOrders,
    routes.createPurchaseOrder,
    routes.viewPurchaseOrder,
    routes.viewDispatch,
    routes.editPurchaseOrder,
    routes.debitNoteGC,
    routes.viewDebitNoteGC,
    routes.editDebitNoteGC,
    routes.createDebitNoteGC,
    routes.mrin,
    routes.createMRIN,
    routes.viewMRIN,
    routes.editMRIN,
  ],

  [roles.vendor]: [
    routes.home,
    routes.dashboard,
    routes.dispatchinfo,
    routes.ViewDispatchNew,
    routes.CreateDispatchNew,
    routes.vendor,
  ],

  [roles.marketingRepresentative]: [
    routes.home,
    routes.dashboard,
  ],

  [roles.generalUser]: [
    routes.home,
  ],

  [roles.managerPackagingDevelopment]: [
    routes.home,
    routes.dashboard,
    routes.packingType,
    routes.createpackingType,
    routes.editpackingType,
    routes.viewpackingType,
  ],

  [roles.purchaseManager]: [
    routes.home,
    routes.dashboard,
    routes.supplier,
    routes.createSupplier,
    routes.viewSupplier,
    routes.editSupplier,
  ],

  [roles.managerPurchaseGCQuotes]: [
    routes.home,
    routes.dashboard,
    routes.quotation,
    routes.createQuotation,
    routes.viewQuotation,
    routes.createQuotationItem,
    routes.viewQuotationItem,
    routes.viewPendingQuotationItem,
    routes.editQuotationItem,
    routes.quote,
    routes.viewQuote,
    routes.editQuote,
    routes.viewQuoteItem,
    routes.viewPendingQuoteItem,
    routes.editQuoteItem,
    // Batch Output
    routes.batchoutput,
    routes.createBatchOutput,
    routes.batchOutputDetails,
    routes.editBatchOutput,
  ],

  [roles.managerPurchasePackaging]: [
    routes.home,
    routes.dashboard,
    routes.packaging,
    routes.viewPackaging,
    routes.quotation,
    routes.createQuotation,
    routes.viewQuotation,
    routes.createQuotationItem,
    routes.viewQuotationItem,
    routes.viewPendingQuotationItem,
    routes.editQuotationItem,
    routes.quote,
    routes.viewQuote,
    routes.editQuote,
    routes.viewQuoteItem,
    routes.viewPendingQuoteItem,
    routes.editQuoteItem,
    routes.packingType,
    routes.viewpackingType,
    routes.editpackingType,
    // Production Schedule
    routes.productionSchedule,
    routes.viewProductionSchedule,
    routes.calendarBlockingProductionSchedule,
    //orderdispatch
    routes.orderDispatchDetails,
    routes.orderDispatch,
  ],

  [roles.packingExecutive]: [
    routes.home,
    routes.dashboard,
    routes.quotation,
    routes.createQuotation,
    routes.viewQuotation,
    routes.createQuotationItem,
    routes.viewQuotationItem,
    routes.viewPendingQuotationItem,
    routes.editQuotationItem,
    routes.quote,
    routes.viewQuote,
    routes.editQuote,
    routes.viewQuoteItem,
    routes.viewPendingQuoteItem,
    routes.editQuoteItem,
    routes.packingType,
    routes.viewpackingType,
    routes.editpackingType,
    routes.createpackingType
  ],

  [roles.purchaseExecutiveME]: [
    routes.home,
    routes.dashboard,
    routes.supplier,
    routes.createSupplier,
    routes.viewSupplier,
    routes.editSupplier,
  ],

  [roles.managerGCStores]: [
    routes.home,
    routes.dashboard,
    routes.productionSchedule,
    routes.viewProductionSchedule,
    routes.calendarBlockingProductionSchedule,
    routes.purchaseOrders,
    routes.viewPurchaseOrder,
    routes.viewDispatch,
    routes.gc,
    routes.viewGC,
    routes.mrin,
    routes.createMRIN,
    routes.viewMRIN,
    routes.editMRIN,
    routes.blendSheet,
    routes.createBlendSheet,
    routes.editBlendSheet,
    // routes.certification,
    routes.viewBlendSheet,
    //orderdispatch
    routes.orderDispatchDetails,
    routes.orderDispatch,
  ],

  [roles.productionAssistant]: [
    routes.home,
    routes.dashboard,
    routes.blendSheet,
    // routes.certification,
    routes.viewBlendSheet,
    routes.sampleRequest,
    routes.viewSampleRequest,
    routes.alternativeSample,
    routes.viewAlternativeSample,
    routes.customerSample,
    routes.viewCustomerSample,
    routes.createBlendSheet,
    routes.editBlendSheet,
    // Batch Output
    routes.batchoutput,
    routes.createBatchOutput,
    routes.batchOutputDetails,
    routes.editBatchOutput,
    routes.orderDispatch,
    routes.orderDispatchDetails,

    // production Schedule
    routes.productionSchedule,
    routes.createProductionSchedule,
    routes.editProductionSchedule,
    routes.viewProductionSchedule,
    routes.calendarBlockingProductionSchedule,
  ],

  [roles.ProductionManager]: [
    routes.home,
    routes.dashboard,
    routes.blendSheet,
    // routes.certification,
    routes.viewBlendSheet,
    routes.sampleRequest,
    routes.viewSampleRequest,
    routes.alternativeSample,
    routes.viewAlternativeSample,
    routes.customerSample,
    routes.viewCustomerSample,
    routes.createBlendSheet,
    routes.editBlendSheet,
    // Batch Output
    routes.batchoutput,
    routes.createBatchOutput,
    routes.batchOutputDetails,
    routes.editBatchOutput,
    routes.orderDispatch,
    routes.orderDispatchDetails,

    // production Schedule
    routes.productionSchedule,
    routes.createProductionSchedule,
    routes.editProductionSchedule,
    routes.viewProductionSchedule,
    routes.calendarBlockingProductionSchedule,
  ],
  [roles.factoryPackingManager]:[
    routes.home,
    routes.dashboard,
    // Finance module routes
    routes.finance,
    routes.editFinanceCosting,
    routes.viewFinanceCosting,
  ],
  [roles.GMPacking]: [
    routes.home,
    routes.dashboard,
    routes.quotation,
    routes.viewQuotation,
    routes.viewQuotationItem,
    routes.packingType,
    routes.viewpackingType,
    routes.orderDispatch,
    routes.orderDispatchDetails,
    routes.productionSchedule,
    routes.viewProductionSchedule,
    routes.calendarBlockingProductionSchedule,
    // Production Schedule
    routes.productionSchedule,
    routes.viewProductionSchedule,
    routes.calendarBlockingProductionSchedule,
    //orderdispatch
    routes.orderDispatchDetails,
    routes.orderDispatch,
  ],
};
export default roles;
